import { Sprite } from "../display/Sprite";
import { PAL } from "../platform/PlatformAdapters";
import { VideoPlayer } from "./VideoPlayer";
import { HideFlags } from "../Const";
export class VideoNode extends Sprite {
    constructor() {
        super();
        this._comp = this.addComponent(VideoPlayer);
        this._comp.hideFlags |= HideFlags.HideAndDontSave;
    }
    get options() {
        return this._comp.options;
    }
    get mode() {
        return this._comp.mode;
    }
    set mode(value) {
        this._comp.mode = value;
    }
    get player() {
        return this._comp.player;
    }
    get source() {
        return this._comp.source;
    }
    set source(value) {
        this._comp.source = value;
    }
    get autoPlay() {
        return this._comp.autoPlay;
    }
    set autoPlay(value) {
        this._comp.autoPlay = value;
    }
    get allowBackground() {
        return this._comp.allowBackground;
    }
    set allowBackground(value) {
        this._comp.allowBackground = value;
    }
    get currentTime() {
        return this._comp.currentTime;
    }
    set currentTime(value) {
        this._comp.currentTime = value;
    }
    get readyState() {
        return this._comp.readyState;
    }
    get videoWidth() {
        return this._comp.videoWidth;
    }
    get videoHeight() {
        return this._comp.videoHeight;
    }
    get duration() {
        return this._comp.duration;
    }
    get ended() {
        return this._comp.ended;
    }
    get loop() {
        return this._comp.loop;
    }
    set loop(value) {
        this._comp.loop = value;
    }
    get playbackRate() {
        return this._comp.playbackRate;
    }
    set playbackRate(value) {
        this._comp.playbackRate = value;
    }
    get volume() {
        return this._comp.volume;
    }
    set volume(value) {
        this._comp.volume = value;
    }
    get muted() {
        return this._comp.muted;
    }
    set muted(value) {
        this._comp.muted = value;
    }
    get paused() {
        return this._comp.paused;
    }
    load(url) {
        this._comp.source = url;
    }
    play() {
        this._comp.play();
    }
    pause() {
        this._comp.pause();
    }
    reload() {
        this._comp.source = this._comp.source;
    }
    canPlayType(type) {
        return PAL.media.canPlayType(type);
    }
    get currentSrc() {
        return this._comp.source;
    }
    get videoTexture() {
        return this._comp.videoTexture;
    }
    set videoTexture(value) {
        if (value)
            this.source = value.source;
        else
            this.source = null;
    }
}
